import React, { useState } from "react";
import "./style.scss";
import { Image } from "antd";
import acaciaLogo from "../../Assets/Images/Acacia-Logo.png";
import Title from "antd/es/typography/Title";
import Logo from "../Logo";
import JoinWaitlistModal from "../JoinWaitlist";
import { Link, useLocation } from "react-router-dom";

const poweredByAcaciaSpanStyle = {
  fontSize: "10px",
  color: "#5d5bf6",
  fontFamily: "Lexend",
  lineHeight: 1.2,
};

const poweredByFirsthandSpanStyle = {
  fontSize: "11px",
  color: "#5d5bf6",
  fontFamily: "Lexend",
};

const NAV_LINKS = [
  { id: "for-talent-link", label: "For Talent", anchor: "built-for-talent" },
  { id: "for-recruiters-link", label: "For Recruiters", anchor: "built-for-hiring-teams" },
  { id: "how-it-works-link", label: "How It Works", anchor: "how-it-works" },
  { id: "faq-link", label: "FAQ", anchor: "faq" },
];

const DeskBar = () => {
  const { pathname } = useLocation();
  const isAcacia = pathname === "/acacia";
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCancel = () => setIsModalOpen(false);

  return (
    <div className="nav-container-desktop">
      <div className="logo_wrapper">
        <Logo />
        <div className="powered-by-line">
          {isAcacia ? (
            <span style={poweredByAcaciaSpanStyle}>
              Powered By <Image src={acaciaLogo} width="60px" preview={false} /> Recruits
            </span>
          ) : (
            <span style={poweredByFirsthandSpanStyle}>
              Powered By Firsthand Partners
            </span>
          )}
        </div>
      </div>
      <div className="nav-link-wrapper">
        {NAV_LINKS.map(({ id, label, anchor }) => (
          <Link to={`/#${anchor}`} key={id}>
            <Title
              level={4}
              id={id}
              className="nav-link-item"
              style={{ marginTop: "0px" }}
            >
              {label}
            </Title>
          </Link>
        ))}
        <Link to="/newsletter">
          <Title
            level={4}
            id="news-letter"
            className="nav-link-item"
            style={{ marginTop: "0px" }}
          >
            Newsletter
          </Title>
        </Link>
      </div>

      <div className="nav-actions">
        <a
          href="https://candidate.stealthjobs.co/"
          target="_blank"
          rel="noreferrer"
          className="nav-link-plain"
        >
          Sign In
        </a>
        <button
          className="contained_button"
          onClick={() => setIsModalOpen(true)}
        >
          Get Started
        </button>
      </div>
      <JoinWaitlistModal
        isModalOpen={isModalOpen}
        handleOk={handleCancel}
        handleCancel={handleCancel}
        defaultValue="seeker"
        setIsModalOpen={setIsModalOpen}
      />
    </div>
  );
};

export default DeskBar;
